const Routes = Object.freeze( {
	toHome: '/',
	toSignIn: '/sign-in',
	toCreateAccount: '/create-account',
	toEmailVerification: '/email-verification',
	toOnboarding: '/onboarding',
	toProject: ( id: number | string ) => `/projects/${id}`,
	toWorkspace: ( id: number | string ) => `/user/workspaces/${id}`,
	toWorkspaceMembers: ( id: number | string ) => `/user/workspaces/${id}/members`,
	toWorkspaceSettings: ( id: number | string ) => `/user/workspaces/${id}/general`,
	toUpgradeWorkspaceSubscription: ( id: number | string ) => `/user/workspaces/${id}/plan?modal=subscription-selection`,
	toForgotPassword: '/forgot',
	toProfile: '/user/profile',
	toProfileNotifications: '/user/profile/notifications'
} );

export default Routes;
